<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
              <b-col cols="12">
                <b-input-group>
                    <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomorintern" placeholder="Budget Number" @keyup.13.native="search()" v-b-tooltip.hover title="awali dan atau akhiri dg %, untuk Mencari pd sebagain text nomor"></b-form-input>
                    <b-form-input v-model="tblData.uraian" placeholder="Budget Name" @keyup.13.native="search()" class="ml-1" style="width:20% !important;"></b-form-input>
                  <b-form-input v-model="tblData.jccostname" placeholder="Item Name" @keyup.13.native="search()" class="ml-1" style="width:30% !important;"></b-form-input>
                  <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" size="sm">
                      <i class="fa fa-refresh"></i> Apply Filter
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button class="btn btn-secondary ml-1" @click="clearFilter()" size="sm">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblBudget" style="font-size:smaller;" 
          responsive striped hover
          :items="data"
          :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          @row-clicked="selectItem"
        >
        <template v-slot:cell(quantity)="data">
            {{data.item.quantity}} {{data.item.unitsize}}
            <span v-if="(data.item.repetit_qty)"> ({{data.item.repetit_qty}} | {{data.item.repetit_nm}})</span>                            
        </template>
        <template v-slot:cell(noprodintern)="data">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; width:100px !important;">
          {{ data.item.noprodintern }}</div>
        </template>

        <!-- <template v-slot:cell(ibbudgetamt)="data">
          {{data.item.ibbudgetamt | numFormat}}
        </template>
        <template v-slot:cell(requestamt)="data">
          {{data.item.requestamt | numFormat}}
        </template> -->
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>

<script>
import budgetinternal from "../../apis/budgetinternal";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            label: "Master#",
            sortable: true
          },
          {
            key: "nomorintern",
            label: "Internal#",
            sortable: true
          },
          {
            key: "uraian",
            label: "Budget Name",
            sortable: true,
          },
          {
            key: "noprodintern",
            label: "No. Prod",
            thStyle: "width:60px",
            sortable: true,
          },
          {
            key: "jccostname",
            label: "Item Name",
            sortable: true
          },
          {
              key: "jccostnote",
              label: "item Note",
              thClass: "text-center",
          },
          {
            key: "quantity",
            label: "quantity",
          },
      ],
      limit:15,
      tblData: {
        total: 0,
        limit:15,
        page:1,
        status: "111",
        sortBy: 'ibtanggal',
        sortDesc: true
      },
      lkuLoading:false
    };
  },
  watch: {
    "tblData.page": function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },

  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await budgetinternal.line(this.tblData);     
      // this.tblData.items=list;
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.uraian='';
        this.tblData.nomor='';
        this.tblData.jccostname='';
    },    
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblBudget.refresh();
       }
    },    
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh() {
      if (this.$refs.tblBudget) this.$refs.tblBudget.refresh();
    },
  }
};
</script>